






































































































































































































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Sticky from 'vue-sticky-directive';
import draggable from 'vuedraggable';
import { namespace } from 'vuex-class';

import InputTypeConfig from '@/views/questionSets/components/InputTypesConfig';
import Question, { inputControl } from '@/views/questionSets/QuestionClass';

const VisitManagement = namespace('visitManagement');

@Component({
  components: {
    draggable
  },
  directives: {
    Sticky
  }
})
export default class QuestionForm extends Vue {
  @Prop({ default: () => new Question() })
  readonly value!: Question;

  private form: Question = new Question(this.value);
  private config: InputTypeConfig = new InputTypeConfig();

  get isOtherExpiry(): boolean {
    return !this.form.expiryOptions.find(
      (option: any) => Number(option.value) === this.form.expiry
    );
  }

  @VisitManagement.State
  private questionInputTypes: any;

  @VisitManagement.Action
  private newQuestion!: (obj: { data: Question }) => Question;

  @VisitManagement.Action
  private updateQuestion!: (obj: { data: Question }) => Question;

  public saveQuestion(): void {
    this.$validator.validateAll().then(async isValid => {
      if (isValid) {
        const { form, $emit, updateQuestion, newQuestion, success } = this;
        console.log({ form });
        if (form.id) await updateQuestion({ data: form });
        else await newQuestion({ data: form });
        success();
      }
    });
  }

  private evalInputTypeConfig(input: inputControl): void {
    if (this.value.inputControl) {
      const { inputControl, config } = this.value;
      if (inputControl.id === input.id && config) {
        this.form.config = JSON.parse(config as string);
        return;
      }
    }
    this.form.config = this.config[input.id];
  }

  @Emit('cancel')
  public cancelQuestion(): void {}

  @Emit()
  public success(): void {}

  private mounted() {
    this.form = new Question(this.value);
  }
}
